export const serviceTimeFormat = 'h:mma';
export const shortDateFormat = 'ddd, D MMMM';
export const longDateFormat = 'dddd, D MMMM YYYY';
export const reverseDateFormat = 'YYYY-MM-DD';
export const standardDateFormat = 'DD-MM-YYYY';
export const sortTimeFormat = 'HHmm';
